import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { GET_SETTINGS } from "../actions";
import { getsettingsListError, getsettingsListSuccess } from "./actions";

const GET_SETTINGS_ERROR = "Settings process failed.";


export function* watchsettingsList() {
  yield takeEvery(GET_SETTINGS, getsettingsList);
}

const getsettingsListAsync = async () => {
  try {
    const lists = [];
    return {
      list: lists,
      message: null,
    };

  } catch (err) {
    return {
      message: GET_SETTINGS_ERROR,
    };
  }
};
// eslint-disable-next-line
function* getsettingsList({ payload }) {
  try {
    const resultReturned = yield call(getsettingsListAsync);
    if (!resultReturned.message) {
      yield put(getsettingsListSuccess(resultReturned));
    } else {
      yield put(getsettingsListError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(getsettingsListError(GET_SETTINGS_ERROR));
  }
}

export default function* rootSaga() {
  yield all([fork(watchsettingsList)]);
}
